<article class="text-center">
  <header>
    <h2>{{title}}</h2>
  </header>
  <picture>
    <img [src]="src"
         [alt]="title">
  </picture>

  <footer>
    <a class="btn btn-default learnMoreTest" routerlinkactive="active" ng-reflect-router-link="/details/prod0001" ng-reflect-router-link-active="active"
      [href]="href">Learn more</a>
  </footer>
</article>
